import { useEffect, useState } from 'react'

interface CursorData {
  clientId: string
  color: string
  userName: string
  x: number
  y: number
}

export function PeerCursors() {
  const [cursors, setCursors] = useState<Map<string, CursorData>>(new Map())

  useEffect(() => {
    function onCursor(e: Event) {
      const detail = (e as CustomEvent<CursorData>).detail
      setCursors(prev => {
        const next = new Map(prev)
        next.set(detail.clientId, detail)
        return next
      })
    }

    function onSelection(e: Event) {
      const detail = (e as CustomEvent<{ clientId: string; blockId: string | null }>).detail
      // Remove cursor when peer makes a selection (keeps things tidy)
      void detail
    }

    window.addEventListener('bst:cursor', onCursor)
    window.addEventListener('bst:selection', onSelection)
    return () => {
      window.removeEventListener('bst:cursor', onCursor)
      window.removeEventListener('bst:selection', onSelection)
    }
  }, [])

  if (cursors.size === 0) return null

  return (
    <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 8000 }}>
      {Array.from(cursors.values()).map(c => (
        <div
          key={c.clientId}
          style={{
            position: 'fixed',
            left: c.x,
            top: c.y,
            transform: 'translate(-2px, -2px)',
            pointerEvents: 'none',
          }}
        >
          {/* Cursor arrow */}
          <svg width="16" height="20" viewBox="0 0 16 20" fill="none">
            <path d="M0 0L0 16L4.5 12L7.5 19L9.5 18L6.5 11L12 11Z" fill={c.color} stroke="#fff" strokeWidth="1" />
          </svg>
          {/* Name label */}
          <div style={{
            position: 'absolute',
            top: '18px',
            left: '8px',
            background: c.color,
            color: '#fff',
            fontSize: '11px',
            fontWeight: 600,
            padding: '2px 6px',
            borderRadius: '4px',
            whiteSpace: 'nowrap',
            lineHeight: '16px',
          }}>
            {c.userName}
          </div>
        </div>
      ))}
    </div>
  )
}
